module.exports = __webpack_public_path__ + "media/images/icons/flat-color-square-email-449961a43b5d999ccb6cfd295ed663c2.png";